import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CommonService } from 'src/app/shared/services/common-service';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { ListSelfTriageFlowchartResponse } from '../../responses/self-triage/list-self-triage-flowchart.response';
import { ListSelfTriageProtocolResponse } from '../../responses/self-triage/list-self-triage-protocol.response';
import { SelfTriageProtocolResponse } from '../../responses/self-triage/self-triage-protocol.response';

@Injectable({
  providedIn: 'root'
})
export class SelfTriageFlowchartService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient, configService: AppConfigService, private endpointBuilder: EndpointBuilderService) {
    super(configService);
  }

  listUnassigned(): Observable<ListSelfTriageFlowchartResponse> {

    let uri = `Flowchart/GetUnassigned`

    return this.httpClient.get<ListSelfTriageFlowchartResponse>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiSelfTriage) + uri, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
